















































































import Vue from 'vue'
import { Component, Prop, Watch } from "vue-property-decorator";

import FileApi from "../../../../../components/File/logic/file-api";
import { FileType } from "../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/types";
import { IPostMessage } from "../../types";
import { MessageAttachments } from "../types";
import TelegramPostPreviewAttachment from "./TelegramPostPreviewAttachment.vue";

@Component({
  data() {
    return {
      FileType
    }
  },
  components: {
    TelegramPostPreviewAttachment
  }
})
export default class PostTypePreview extends Vue {
  @Prop() message!: IPostMessage

  @Prop() targetToUpload!: string

  @Prop() update!: () => void

  @Prop({ required: false }) postsCount?: number

  @Prop() i18n!: any

  scriptLoaded = false

  fileApi = new FileApi()

  @Watch('postsCount')
  postsCountWatcher(): void {
    this.updateGroup()
  }

  @Watch('firstMessage.attachments', { deep:true })
  onChange():void {
    this.updateGroup()
  }

  get firstMessage() {
    return this.message.variants[0] ?? { text: '', attachments: [] }
  }

  getNotImageOrVideo(arg: string): Array<MessageAttachments> {
    const imageOrVideo: Array<MessageAttachments> = []
    const other: Array<MessageAttachments> = []

    this.firstMessage.attachments!.forEach((attachment) => {
      if ([ FileType.Image, FileType.Video, FileType.SpoilerImage, FileType.SpoilerVideo ].includes(attachment.type)) {
        imageOrVideo.push(attachment)
      } else {
        other.push(attachment)
      }
    })

    if(arg === FileType.Image || arg === FileType.SpoilerImage) {
      return imageOrVideo
    } else {
      return other
    }
  }

  updateGroup (): void {
    this.$nextTick(() => {
      const postBody = this.$refs['attachments'] as Vue
      if (postBody) {
        (this.$refs['attachments'] as any).__inited = false;
        (window as any).TGrouped.init(postBody)
      }
    })
  }

  getPreview(attachmentKey: string): Pick<CSSStyleDeclaration, 'backgroundImage'> {
    return { backgroundImage: `url(${ this.fileApi.getFilePreviewUrl(attachmentKey, encodeURI(this.targetToUpload)) })` }
  }

  created(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context:PostTypePreview = this

    if (!(window as any).TGrouped) {
      const recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://telegram.org/js/widget-frame.js')
      document.head.appendChild(recaptchaScript)
      recaptchaScript.onload = function () {
        (window as any).TWidgetPost.init()
        context.updateGroup()

        context.scriptLoaded = true
      }
    } else {
      this.scriptLoaded = true

      this.updateGroup()
      this.$nextTick(() => {
        const attachments = this.$refs.attachment
        if (Array.isArray(attachments)) {
          attachments.forEach(attachment => {
            (window as any).TPhoto.init(attachment)
          })
        }
      })
    }
  }
}
